module.exports = __webpack_public_path__ + "static/img/bind1.823df583.png";